var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, createRef } from 'react';
import { Pressable, Platform, ActivityIndicator, Animated, Easing, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedImageView } from '../Image/AnimatedImageView';
const AnimatedPressable = Animated.createAnimatedComponent(Pressable);
let FabBaseButtonView = class FabBaseButtonView extends Component {
    constructor(props) {
        super(props);
        this.ref = createRef();
        this.state = {
            backgroundAnimation: new Animated.Value(0),
            isHovered: false
        };
        this.animationDuration = 200;
        this.backgroundStates = this.loadBackgroundStates();
        this.handleClick = this.handleClick.bind(this);
        this.handleHover = this.handleHover.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }
    loadBackgroundStates() {
        var _a;
        return {
            disabled: {
                color: this.props.disableBackground || this.props.defaultBackground || '',
                value: -2
            },
            inactive: {
                color: this.props.inactiveBackground || this.props.defaultBackground || '',
                value: -1
            },
            default: {
                color: ((_a = this.props.containerStyle) === null || _a === void 0 ? void 0 : _a.backgroundColor) || this.props.defaultBackground || '',
                value: 0
            },
            press: {
                color: this.props.pressBackground || this.props.defaultBackground || '',
                value: 1
            }
        };
    }
    componentDidMount() {
        var _a, _b;
        if (Platform.OS === 'web' && this.props.hover) {
            (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', this.handleHover);
            (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', this.handleBlur);
        }
    }
    componentWillUnmount() {
        var _a, _b;
        if (Platform.OS === 'web' && this.props.hover) {
            (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseenter', this.handleHover);
            (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('mouseleave', this.handleBlur);
        }
    }
    componentDidUpdate() {
        this.backgroundStates = this.loadBackgroundStates();
        if (this.props.disabled) {
            return Animated.timing(this.state.backgroundAnimation, {
                toValue: this.backgroundStates.disabled.value,
                duration: this.animationDuration,
                useNativeDriver: false
            }).start();
        }
        if (this.props.inactive) {
            return Animated.timing(this.state.backgroundAnimation, {
                toValue: this.backgroundStates.inactive.value,
                duration: this.animationDuration,
                useNativeDriver: false
            }).start();
        }
        if (this.state.isHovered) {
            return true;
        }
        return Animated.timing(this.state.backgroundAnimation, {
            toValue: this.props.value
                ? this.backgroundStates.press.value
                : this.backgroundStates.default.value,
            duration: this.animationDuration,
            useNativeDriver: false,
            easing: Easing.linear
        }).start();
    }
    handleClick() {
        if (this.props.loading || this.props.inactive || this.props.disabled) {
            return;
        }
        Animated.sequence([
            Animated.timing(this.state.backgroundAnimation, {
                toValue: this.backgroundStates.press.value,
                duration: this.animationDuration,
                easing: Easing.linear,
                useNativeDriver: false
            }),
            Animated.timing(this.state.backgroundAnimation, {
                toValue: this.backgroundStates.default.value,
                duration: this.animationDuration,
                easing: Easing.linear,
                useNativeDriver: false
            })
        ]).start(() => {
            Animated.timing(this.state.backgroundAnimation, {
                toValue: this.backgroundStates.default.value,
                duration: this.animationDuration,
                easing: Easing.linear,
                useNativeDriver: false
            }).start();
        });
        typeof this.props.onPress === 'function' && this.props.onPress();
    }
    handleHover() {
        if (this.props.inactive || this.props.disabled) {
            return;
        }
        this.setState({ isHovered: true });
        return typeof this.props.onHover === 'function' && this.props.onHover();
    }
    handleBlur() {
        this.setState({ isHovered: false });
        Animated.timing(this.state.backgroundAnimation, {
            toValue: this.backgroundStates.default.value,
            duration: this.animationDuration,
            useNativeDriver: false
        }).start();
        return typeof this.props.onBlur === 'function' && this.props.onBlur();
    }
    getAnimationStyles() {
        if (this.props.defaultBackground && this.props.pressBackground && this.props.hoverBackground) {
            const backgroundColor = this.state.backgroundAnimation.interpolate({
                inputRange: [this.backgroundStates.disabled.value, this.backgroundStates.inactive.value, this.backgroundStates.default.value, this.backgroundStates.press.value],
                outputRange: [this.backgroundStates.disabled.color, this.backgroundStates.inactive.color, this.backgroundStates.default.color, this.backgroundStates.press.color]
            });
            return {
                backgroundColor
            };
        }
        return {};
    }
    render() {
        var _a, _b, _c, _d;
        let _e = this.props, { imageLeft, loading, rounded, iconLeftSize, color, wrapperStyle, dense, size, style, containerStyle, iconLeft, iconLeftStyle, text, textStyle, onPress, children, onHover, onBlur } = _e, otherProps = __rest(_e, ["imageLeft", "loading", "rounded", "iconLeftSize", "color", "wrapperStyle", "dense", "size", "style", "containerStyle", "iconLeft", "iconLeftStyle", "text", "textStyle", "onPress", "children", "onHover", "onBlur"]);
        const btnSize = size || 'md';
        const btnText = style === null || style === void 0 ? void 0 : style[`${btnSize}Text`];
        const btnIcon = style === null || style === void 0 ? void 0 : style[`${btnSize}Icon`];
        if (!iconLeftStyle) {
            iconLeftStyle = {};
        }
        iconLeftStyle.height = iconLeftSize || ((_b = (_a = this.props.style) === null || _a === void 0 ? void 0 : _a[`${btnSize}Icon`]) === null || _b === void 0 ? void 0 : _b.height) || 18;
        iconLeftStyle.width = iconLeftSize || ((_d = (_c = this.props.style) === null || _c === void 0 ? void 0 : _c[`${btnSize}Icon`]) === null || _d === void 0 ? void 0 : _d.height) || 18;
        const animations = this.getAnimationStyles();
        return (_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.wrapper, wrapperStyle], children: _jsxs(AnimatedPressable, Object.assign({ ref: this.ref }, otherProps, { style: [style === null || style === void 0 ? void 0 : style.container, style === null || style === void 0 ? void 0 : style[btnSize], dense && (style === null || style === void 0 ? void 0 : style.dense), containerStyle, rounded && (style === null || style === void 0 ? void 0 : style.rounded), animations], onPress: this.handleClick, children: [loading && (_jsx(ActivityIndicator, {})), (typeof iconLeft === 'string' || !!imageLeft) && !loading && (_jsx(AnimatedImageView, { image: imageLeft, icon: iconLeft, containerStyle: Object.assign(Object.assign(Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.text), btnIcon), iconLeftStyle), !text && { marginEnd: 0 }), color: color })), !!text && !loading && (_jsx(AnimatedTextView, { textStyle: [btnText, dense && (style === null || style === void 0 ? void 0 : style.denseText), textStyle], children: text })), !loading && children] })) }));
    }
};
FabBaseButtonView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.toggleBaseButton,
        style: {
            wrapper: {
                flex: 1
            },
            container: {
                flex: 2,
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 8
            },
            hint: {},
            lg: {
                padding: 20
            },
            lgText: {
                fontSize: 20,
                maxWidth: 215,
                fontWeight: 'bold',
                textTransform: 'capitalize'
            },
            lgIcon: {
                height: 20,
                width: 20,
                marginEnd: 10
            },
            md: {
                paddingHorizontal: 16,
                paddingVertical: 15
            },
            mdText: {
                fontSize: 18,
                maxWidth: 165,
                fontWeight: 'bold',
                textTransform: 'capitalize'
            },
            mdIcon: {
                height: 18,
                width: 18,
                marginEnd: 10
            },
            sm: {
                paddingVertical: 12,
                paddingHorizontal: 16
            },
            smText: {
                fontSize: 16,
                maxWidth: 120,
                fontWeight: 'bold',
                textTransform: 'capitalize'
            },
            smIcon: {
                height: 16,
                width: 16,
                marginEnd: 8
            },
            denseText: {
                fontWeight: 'normal',
                maxWidth: '100%'
            },
            dense: {
                paddingHorizontal: 0,
                paddingVertical: 0
            },
            rounded: {
                borderRadius: 50
            },
            text: {}
        }
    }),
    __metadata("design:paramtypes", [Object])
], FabBaseButtonView);
export { FabBaseButtonView };
